import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarRateSheet(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);
    
    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="RateSheet"?"":"RateSheet")} title="RateSheet" className={props.activeMenu == "RateSheet" ? "sidenav-expanded-active pointer px-0 sidenavbar-text" : "pointer px-0 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("ratesheet:ratesheet:view")?false:true}>
                <i className="fa fa-money sidenavbar-icon px-3"></i>
                <span className="mx-3 sidenavbar-text">Rate Sheet
                    <i className={showMenu=="RateSheet"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>
            <ul className={showMenu == "RateSheet" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/ratesheet/slotratesheet")} title="SlotRateSheet" 
                className={props.activeSubMenu == "SlotRateSheet" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("ratesheet:slotratesheet:view")?false:true}>
                    <span className="mx-3">Slot Rate Sheet</span>
                </a>
            </ul>
            <ul className={showMenu == "RateSheet" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/ratesheet/slotagreement")} title="SlotAgreement" 
                className={props.activeSubMenu == "SlotAgreement" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("ratesheet:slotagreement:view")?false:true}>
                    <span className="mx-3">Slot Agreement</span>
                </a>
            </ul>
        </>
    );
}

export default SideNavBarRateSheet;
